<script>
  import ColorPicker from '../../Common/ColorPicker.svelte';
  import { showSettingsPopup } from '../service/LmsUIService';
  import IconStyling from './IconStyling.svelte';
  import { External, M } from '../../external';

  export let styling, onChange;

  let showIconsStyling = () => {
    showSettingsPopup({
      component: (target) =>
        new IconStyling({
          target: target,
          props: {
            styling: styling.iconStyling,
            onChange: onChange
          }
        })
    });
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> brush </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.SIDEBAR_STYLING}</h4>

  <div class="popup-input-wrapper f-left mt-5">
    <div class="info">
      <h5>{M.SIDEBAR_POSITION}</h5>
    </div>
    <select class="page-select" bind:value={styling.position} on:change={onChange}>
      <option value="left">{M.LEFT}</option>
      <option value="right">{M.RIGHT}</option>
    </select>
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.bg.color}
      bind:colorClass={styling.bg.colorClass}
      onChange={onChange}
      label={M.SIDEBAR_BACKGROUND_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.textStyling.fg.color}
      bind:colorClass={styling.textStyling.fg.colorClass}
      onChange={onChange}
      label={M.TEXT_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.textStyling.badgeFg.color}
      bind:colorClass={styling.textStyling.badgeFg.colorClass}
      onChange={onChange}
      label={M.BADGE_TEXT_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.textStyling.badgeBg.color}
      bind:colorClass={styling.textStyling.badgeBg.colorClass}
      onChange={onChange}
      label={M.BADGE_BG_COLOR}
    />
  </div>

  <div class="col20 mb-15 mt-15 f-left gray-section product-select-wrapper">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.ICONS_STYLING}</h4>
      <a on:click={showIconsStyling} class="text-link blue-text" data-role="circleIconsStyling">{M.CHANGE}</a>
    </div>
  </div>
</div>
